import { useGetList } from 'react-admin';
import { AVATAR_TRACEABILITY_NOTES } from '@/utils/CONST';

interface Params {
    filter?: any;
    avatarId: string | undefined;
}

interface Result {
    history: any[];
    isLoading: boolean;
    refetch: any;
}

const useGetAvatarNotesHistory = ({ avatarId }: Params): Result => {
    const { data, isLoading, refetch }: any = useGetList(
        AVATAR_TRACEABILITY_NOTES,
        {
            filter: {
                'type-item': 'note',
                avatarId,
            },
        },
        {
            enabled: avatarId !== undefined && avatarId !== null,
        },
    );

    return {
        history: data,
        isLoading,
        refetch,
    };
};

export default useGetAvatarNotesHistory;
